import { render, staticRenderFns } from "./EmailTrackingDetailWidgetLocal.vue?vue&type=template&id=4deafe34&scoped=true&"
import script from "./EmailTrackingDetailWidgetLocal.vue?vue&type=script&lang=js&"
export * from "./EmailTrackingDetailWidgetLocal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTrackingDetailWidgetLocal.vue?vue&type=style&index=0&id=4deafe34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deafe34",
  null
  
)

export default component.exports